const settings = {
  scene1: {
    title: 'HOW TO BREW',
    logo: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Flogo.png?alt=media&token=6e0e9e2a-a6c3-497a-accc-d937b8570110'
  },
  scene2: {
    text1: 'Learn how to brew',
    text2: 'using a coffee press',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fbg1.jpg?alt=media&token=2fee2928-f07d-469d-bb86-22807c5b500c'
  },
  scene3: {
    video: {
      url: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fcoffee-video.mp4?alt=media&token=147213b1-c22c-4eed-a38b-422823d7cf9f',
      thumbUrl: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fvideo-placeholder.jpg?alt=media&token=cd46091d-1176-447f-875c-16704e49bcf3'
    },
    title: 'Brewing with a coffee press',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    button: 'Get started'
  },
  scene4: {
    title: 'Coffee Header',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    tip: 'Lorem ipsum coffee tip, long enough for a couple of lines',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fbg2.jpg?alt=media&token=da58aebf-30e3-49d2-b082-e6566e5984cb'
  },
  scene5: {
    title: 'Coffee Header',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    tip: 'Lorem ipsum coffee tip, long enough for a couple of lines',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fbg3.jpg?alt=media&token=913cf02a-f572-4925-a406-7fbc51ad47bb'
  },
  scene6: {
    title: 'Coffee Header',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    tip: 'Lorem ipsum coffee tip, long enough for a couple of lines',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fbg4.jpg?alt=media&token=d2e9d35c-456d-4bfe-b314-cf7f87ab972c'
  },
  scene7: {
    img: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fbag.png?alt=media&token=d8ef9a7b-e166-4ae3-9cda-b47c77ec73ce',
    title: 'Spotlight on: Packaging',
    description: ['The way that coffee is packaged is critical to preserving the uniqueness of a particular harvest, especially in humid climates.'],
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fbg3.jpg?alt=media&token=913cf02a-f572-4925-a406-7fbc51ad47bb'
  },
  scene8: {
    title: 'Share + Inspire',
    description: 'Coffee is all about community. It\'s our love, passion, and quest for the highest quality of coffee that brings people together.',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Fcoffee%2Fbg5.jpg?alt=media&token=8470f6aa-2856-459b-b8c9-1e50029a6306',
    button: 'SHOP PHOENIX',
    buttonFieldType: 'appLinks',
    buttonUrl: 'https://google.com',
    facebook: 'https://fb.me/yay',
    twitter: 'https://twitter.com/me',
    email: '1@mail.com',
    phone: '+19723456789',
    shareTitle: 'Share',
    shareSubtitle: 'With friends'
  },
  appSettings: {
    title: 'Instant App'
  }
}

export default settings



// WEBPACK FOOTER //
// ./src/templates/app-website/template/settings.js